import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowToastColor = createSelector(
  [(store: RootState) => store.profileDetail.showToastColor],
  (usersList) => usersList
);
